import React, { useEffect, useState } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import AuthSimpleLayout from './AuthSimpleLayout';
import is from 'is_js';
import MainLayout from './MainLayout';
import SettingsToggle from 'components/settings-panel/SettingsToggle';
import SettingsPanel from 'components/settings-panel/SettingsPanel';
import AuthCardRoutes from 'components/authentication/card/AuthCardRoutes';
import AuthSplitRoutes from 'components/authentication/split/AuthSplitRoutes';
import ErrorLayout from './ErrorLayout';
import WizardAuth from 'components/authentication/wizard/WizardAuth';
import Landing from 'components/pages/landing/Landing';
import { ToastContainer } from 'react-toastify';
import { getItemFromStore } from 'helpers/utils';

const Layout = () => {
  const HTMLClassList = document.getElementsByTagName('html')[0].classList;
  const [tokenFound, setTokenFound] = useState(false);

  useEffect(() => {
    if (is.windows()) {
      HTMLClassList.add('windows');
    }
    if (is.chrome()) {
      HTMLClassList.add('chrome');
    }
    if (is.firefox()) {
      HTMLClassList.add('firefox');
    }
    if (getItemFromStore('aidaToken', false)) {
      setTokenFound(true);
    }
  }, [HTMLClassList]);

  return (
    <>
      <Switch>
        <Route path="/landing" component={Landing} />
        <Route path="/errors" component={ErrorLayout} />
        <Route path="/authentication/simple" component={AuthSimpleLayout} />
        <Route path="/authentication/card" component={AuthCardRoutes} />
        <Route path="/authentication/split" component={AuthSplitRoutes} />
        <Route path="/authentication/wizard" component={WizardAuth} />
        <Route path="/app" component={AuthSimpleLayout} />
        <Route component={MainLayout} />
        <Redirect to="/app/login" />
      </Switch>
      <ToastContainer></ToastContainer>
    </>
  );
};

export default Layout;
